import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.billing'),
    id: 'clients',
    sidebar: [
        {
            id: 'billable',
            label: i18n.t('configuration.sections.billing'),
            icon: 'fal fa-calculator',
            routeName: 'BillableClients',
            active: true,
            hasChildren: true,
            children: [
                {
                    id: 'rates',
                    label: i18n.tc('configuration.sections.rate', 2),
                    icon: 'far fa-money-check',
                    routeName: 'BillableRates',
                    hasChildren: false
                },
                {
                    id: 'clients',
                    label: i18n.tc('configuration.sections.client', 2),
                    icon: 'far fa-briefcase',
                    routeName: 'BillableClients',
                    hasChildren: false
                }
            ]
        },
        {
            id: 'nonBillable',
            label: i18n.t('configuration.sections.serviceActivity'),
            icon: 'fal fa-user-clock',
            routeName: 'NonBillableLocalConcepts',
            active: true,
            hasChildren: true,
            children: [
                {
                    id: 'clients',
                    label: i18n.tc('configuration.sections.concept', 2),
                    icon: 'far fa-briefcase',
                    routeName: 'NonBillableLocalConcepts',
                    hasChildren: false
                }
            ]
        }
    ]
}
